'use strict';

/**
 * User Service
 */
module.service('clientService', [ 'Restangular', '$q', function(Restangular, $q) {

    /*
     * ------------------------------------------------------------------------------
     * SERVICE FUNCTIONS
     * -------------------------------------------------------------------------------
     */
    var clientResource = Restangular.all('client');
    var clientSimpleResource = Restangular.all('clientsimple');

    return {
    	//devuelve con paginacion
        searchClients : function(filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            clientSimpleResource.customGET('', filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        //No lo devuelve en pagianción sino en una lista (ttodos)
        searchAllClients : function(filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            clientSimpleResource.customGET('all', filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        getClient : function(id) {
            var deferred = $q.defer();
            var answer = new restResponse();

            Restangular.one('client', id).get().then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        createClient : function(client) {
            var deferred = $q.defer();
            var answer = new restResponse();

            clientResource.post(client).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });

            return deferred.promise;
        },
        
        removeClient: function(idClient) {
            var deferred = $q.defer();
            var answer = new restResponse();

            Restangular.one('client', idClient).remove().then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });

            return deferred.promise;
        },

        enableClient : function(idClient){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customPUT(null, idClient + '/enable').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        disableClient : function(idClient){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customPUT(null, idClient + '/disable').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        getHomeClient : function(id) {
            var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customGET(id + '/home', null).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        getClientBasicInfo: function(idClient){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientSimpleResource.customGET(idClient,{}).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        searchClientContacts: function(idClient, filters){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customGET(idClient + '/contact',filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        createClientContact: function(idClient, contactModel){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customPOST(contactModel, idClient + '/contact').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        removeClientContact: function(idClient, idContact) {
            var deferred = $q.defer();
            var answer = new restResponse();

            Restangular.one('client', idClient).one('contact', idContact).remove().then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });

            return deferred.promise;
        },
        
        getClientContact: function(idClient, idContact){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customGET(idClient + '/contact/' + idContact, {}).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        updateClientContact : function(idClient, idContact, updateModel){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customPUT(updateModel, idClient + '/contact/' + idContact).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        asignContactAsPrincipal: function(idClient, contactModel){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customPUT(contactModel, idClient + '/asigncontact').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        updateClient : function(idClient, updateModel) {
            var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customPUT(updateModel, idClient).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        searchSites : function(idClient, filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            clientResource.customGET(idClient + '/site', filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        searchSitesBasicInfo : function(idClient, filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            Restangular.one('client',idClient).customGET('basicinfo',filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        getClientSite: function(idClient, idSite){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customGET(idClient + '/site/' + idSite, {}).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        createClientSite: function(idClient, siteModel){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customPOST(siteModel, idClient + '/site').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        getClientSiteContact: function(idClient, idSite){
        	var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.one('client',idClient).one('site',idSite).customGET('contact').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        removeClientSite: function(idClient, idSite) {
            var deferred = $q.defer();
            var answer = new restResponse();

            Restangular.one('client', idClient).one('site', idSite).remove().then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });

            return deferred.promise;
        },

        updatedClientSite: function(idClient, idSite, siteModel){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customPUT(siteModel, idClient + '/site/' + idSite).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        asignContactToSite: function(idClient, idSite, contactModel){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customPUT(contactModel, idClient + '/site/' + idSite + '/asigncontact').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        searchAreas : function(idClient, idSite, filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            clientResource.customGET(idClient + '/site/' + idSite + '/area', filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        searchAreasBasicInfo : function(idClient, idSite, filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            Restangular.one('client',idClient).one('site',idSite).customGET('basicinfo',filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        createClientArea : function(idClient, idSite, areaModel) {
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customPOST(areaModel, idClient + '/site/' + idSite + '/area').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        removeClientArea: function(idClient, idSite, idArea) {
            var deferred = $q.defer();
            var answer = new restResponse();

            Restangular.one('client', idClient).one('site', idSite).one('area', idArea).remove().then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });

            return deferred.promise;
        },
        
        getClientArea: function(idClient, idSite, idArea){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customGET(idClient + '/site/' + idSite + '/area/' + idArea, {}).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        updatedClientArea: function(idClient, idSite, idArea, areaModel){
        	var deferred = $q.defer();
            var answer = new restResponse();
            clientResource.customPUT(areaModel, idClient + '/site/' + idSite + '/area/' + idArea).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
    };
} ]);